import possibleTypes from '@/possibleTypes.json';
import { InMemoryCacheConfig } from '@apollo/client';

export const cacheConfig: InMemoryCacheConfig = {
  possibleTypes,
};
